// Ces deux fonctions permettent de formatter les date envoyer par le serveur (format SQL écrit en BDD)
// pour les convertir en chaine de caractère lisible

export const formatSQLDateLong = (dateTime) => {
	// regular expression split that creates array with: year, month, day, hour, minutes, seconds values
	let dateTimeParts= dateTime.split(/[- :]/);
	// monthIndex begins with 0 for January and ends with 11 for December so we need to decrement by one
	dateTimeParts[1]--;
	// New date object
	const dateObject = new Date(...dateTimeParts);
	// Option to display data like for example : "mardi 12 mai à 17:25:65"
	const options = { weekday: "long", month: "long", day: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };
	const formatedDateTime = dateObject.toLocaleDateString("fr-FR", options);
	return formatedDateTime;
};

export const formatSQLDateShort = (dateTime) => {
	// regular expression split that creates array with: year, month, day, hour, minutes, seconds values
	let dateTimeParts= dateTime.split(/[- :]/);
	// monthIndex begins with 0 for January and ends with 11 for December so we need to decrement by one
	dateTimeParts[1]--;
	// New date object
	const dateObject = new Date(...dateTimeParts);
	// Option to display data like for example : "mardi 12 mai à 17:25:65"
	const options = { weekday: "long", month: "long", day: "2-digit" };
	const formatedDateTime = dateObject.toLocaleDateString("fr-FR", options);
	return formatedDateTime;
};